/*@ngInject*/
const DataSetActionRepository = function (baseRepository) {

    angular.extend(this, baseRepository);

    this.loadDataSetActionByName = function (uri) {
        var url = '/rest/Actions',
            config = {
                params: {
                    uri: uri
                }
            };
        return this.get(url, config);
    };

    this.getReferences = function (dataSetName) {
        var url = '/rest/DataSet/references',
            config = {
                params: {
                    dataSetName: dataSetName
                }
            };
        return this.get(url, config);
    };

    this.deleteDataSetByName = function (dataSetName, forceDelete) {
        var url = '/rest/DataSet/delete',
            config = {
                params: {
                    forceDelete: forceDelete,
                    dataSetName: dataSetName
                }
            };
        return this.delete(url, config);
    };
};

angular.module('ums.configuration')
    .service('dataSetActionRepository', DataSetActionRepository);
